import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IProductSuggestRequest } from '../models/ProductSuggestListModel'

export class AddProductSuggestApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/productSuggest/addProductSuggest',
      requesterInfo,
    })
  }

  public async addProductSuggest(request: IProductSuggestRequest): Promise<any> {
    return await this.postAsync<any>(request)
  }
}
